import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import AuthShell from "./AuthShell";
import { postAuthPath, getPending } from "@/lib/menuFunnel";
import { t } from "@/i18n";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      nav(postAuthPath());
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={t("login.bon_retour")}
      subtitle={getPending() ? t("login.connectez_vous_pour_voir_votre_analyse_com") : t("login.connectez_vous_pour_suivre_la_rentabilite")}
      footer={<>{t("login.pas_encore_de_compte")} <Link to="/register" className="font-semibold text-foreground underline-offset-4 hover:underline" data-testid="go-register-link">{t("login.creer_un_compte")}</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">{t("common.email")}</Label>
          <Input id="email" type="email" required autoComplete="email" data-testid="login-email-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="vous@restaurant.fr" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">{t("login.mot_de_passe")}</Label>
            <Link to="/forgot-password" className="text-xs text-muted-foreground hover:text-foreground" data-testid="auth-forgot-password-link">{t("login.mot_de_passe_oublie")}</Link>
          </div>
          <Input id="password" type="password" required autoComplete="current-password" data-testid="login-password-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </div>
        {error && <p className="text-sm text-rose-500" data-testid="login-error">{error}</p>}
        <Button type="submit" className="w-full active:scale-[0.98]" disabled={loading} data-testid="login-submit-btn">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{t("common.se_connecter")}
        </Button>
        <p className="rounded-lg border bg-muted/40 p-3 text-xs text-muted-foreground" data-testid="demo-credentials-hint">
          {t("login.compte_demo")} <span className="num text-foreground">demo@mymenuprofit.fr</span> / <span className="num text-foreground">Demo1234!</span>
        </p>
      </form>
    </AuthShell>
  );
}
